<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.3537 6.35375L8.35366 11.3537C8.30722 11.4002 8.25207 11.4371 8.19138 11.4623C8.13068 11.4874 8.06561 11.5004 7.99991 11.5004C7.9342 11.5004 7.86913 11.4874 7.80844 11.4623C7.74774 11.4371 7.69259 11.4002 7.64616 11.3537L2.64616 6.35375C2.57615 6.28382 2.52847 6.1947 2.50914 6.09765C2.48982 6.00061 2.49972 5.90002 2.53759 5.8086C2.57547 5.71719 2.63962 5.63908 2.72191 5.58414C2.80421 5.5292 2.90096 5.49992 2.99991 5.5H12.9999C13.0989 5.49992 13.1956 5.5292 13.2779 5.58414C13.3602 5.63908 13.4243 5.71719 13.4622 5.8086C13.5001 5.90002 13.51 6.00061 13.4907 6.09765C13.4713 6.1947 13.4237 6.28382 13.3537 6.35375Z"
      fill="black"
    />
  </svg>
</template>
<script lang="ts" setup></script>
